
import styled from "styled-components";

import CompanyNameInput from "../../loadUpdate/sections/yetkiliBilgi/inputs/CompanyNameInput";
import RouteLineForYetkiliBilgi from "../../loadUpdate/sections/shared/others/RouteLineForYetkiliBilgi";
import CompanyMailInput from "../../loadUpdate/sections/yetkiliBilgi/inputs/CompanyMailInput";
import YetkiliNameInput from "../../loadUpdate/sections/yetkiliBilgi/inputs/YetkiliNameInput";
import YetkiliPhoneNumberInput from "../../loadUpdate/sections/yetkiliBilgi/inputs/YetkiliPhoneNumberInput";
import AliciSmsDogrulamaCheckbox from "../../loadUpdate/sections/bosaltma/inputs/aliciBilgileri/AliciSmsDogrulamaCheckbox";
import SmsDogrulamaPhoneNumberInput from "../../loadUpdate/sections/bosaltma/inputs/aliciBilgileri/SmsDogrulamaPhoneNumberInput";

const Container = styled.div`
  width: auto;

  color: ${({ theme }) => theme.mainTextColor};

  .route-list {
    display: flex;
    flex-direction: column;
    width: auto;

    .route-item {
      width: auto;
      display: flex;

      .form-side {
        display: flex;
        flex-direction: column;
        margin-left: 6px;

        .item-top {
          padding-left: 3px;
          border-bottom: 1px solid ${({ theme }) => theme.mainTextColor};
          padding-bottom: 2px;
          display: flex;
          justify-content: space-between;

          h4 {
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-xl);
          }

          .delete-btn {
            padding: 4px 14px;
            border-radius: 5px;
            background-color: ${({ theme }) => theme.secondaryBgColor};
            font-size: var(--font-size-sm);
            font-size: 12px;
            font-weight: var(--font-weight-lg);
            cursor: pointer;

            &:hover {
              background-color: ${({ theme }) => theme.mainTextColor};
              color: ${({ theme }) => theme.mainBgColor};
            }
          }
        }

        .input-list {
          display: flex;
          flex-direction: column;
          padding-left: 20px;
          padding-top: 20px;
          gap: 20px;
          margin-bottom: 40px;

          .grp {
            display: flex;
            align-items: center;
            gap: 10px;
          }

          .grp-top-aligned {
            display: flex;
            align-items: flex-start;
            gap: 10px;
          }
        }
      }
    }
  }

  .bottom-btn-container {
    width: 100%;
    padding: 50px;
    display: flex;
    justify-content: space-between;

    .icon {
      fill: var(--color-main);
      font-size: 1.6rem;
    }

    span {
      color: ${({ theme }) => theme.mainTextColor};
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-xl);
    }
  }
`;

const YetkiliBilgiSection = ({ data, setData }) => {

  const yuklemeList = data.filter(item => item.loadOrUnload === 0).map((item, i) => {
    return {...item, typeOrder:i+1, locationType: "Yükleme"}
  }) 

  const bosaltmaList = data.filter(item => item.loadOrUnload === 1).map((item, i) => {
    return {...item, typeOrder:i+1, locationType: "Boşaltma"}
  }) 

  return (
    <Container>
      <div className="route-list">
        {[...yuklemeList, ...bosaltmaList].map((item, i) => (
          <div className="route-item">
            <RouteLineForYetkiliBilgi type={i === 0 ? "start" : "mid"} isEnd={i+1 === data.length} />
            <div className="form-side">
              <div className="item-top">
                <h4 className="h4">{`${item.typeOrder}.${item.locationType} (${item.location})`}</h4>
              </div>
              <div className="input-list">
                <CompanyNameInput item={item} keyData={"companyName"} data={data} setData={setData} name={"companyName" +item.id} labelText={item.loadOrUnload === 0 ? "Gönderici Adı/Ünvanı" : "Alıcı Adı/Ünvanı"} isRequired={false}/>
                <CompanyMailInput item={item} keyData={"mailAddress"} data={data} setData={setData} name={"companyMail" +item.id} labelText={item.loadOrUnload === 0 ? "Gönderici Mail Adresi" : "Alıcı Mail Adresi"} isRequired={false}/>
                <YetkiliNameInput item={item} keyData={"routePointPersonName"} data={data} setData={setData} name={"yetkiliName" +item.id} labelText={item.loadOrUnload === 0 ? "Yükleme Yetkilisi Adı Soyadı" : "Boşaltma Yetkilisi Adı Soyadı"} isRequired={false}/>
                <YetkiliPhoneNumberInput item={item} keyData={"routePointPersonPhoneNumber"} data={data} setData={setData} name={"yetkiliPhone" +item.id} labelText={item.loadOrUnload === 0 ? "Yükleme Yetkilisi Telefonu" : "Boşaltma Yetkilisi Telefonu"} isRequired={false}/>
                {
                  item.locationType === "Boşaltma" &&
                  <AliciSmsDogrulamaCheckbox item={item} data={data} setData={setData} keyData={"smsVerification"} labelText={"Yük Alıcıya SMS Doğrulama Kodu İle Teslim Edilsin"}/>
                }
                {
                  item.smsVerification &&
                  <SmsDogrulamaPhoneNumberInput item={item} data={data} setData={setData} keyData={"smsVerificationPhoneNumber"} name={"smsVerificationPhoneNumber"} labelText={"Sms doğrulamasının Gönderileceği Telefon"}/>
                }
              </div>
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
};

export default YetkiliBilgiSection